import { resolveSinglePageRoot } from '@/lib/routes/singlePageScope.js';
import getInitialRuntimeSinglePage from '@/redux/reducers/pieveReducer/getInitialRuntimeSinglePage.js';

/* The page a single-page visit is pinned to: the one the document opened on. Empty when the visit
   is not single-page. Read once, like the switch itself, so moving within the page never moves
   the pin. */
const getInitialRuntimeSinglePageRoot = () => {
  if (typeof window === 'undefined' || !getInitialRuntimeSinglePage()) {
    return '';
  }

  return resolveSinglePageRoot(window.location.pathname);
};

export default getInitialRuntimeSinglePageRoot;
